export function GetMockCaseQueryList() {
  return [
    {
      id: 77,
      queryDate: "2022-09-22T15:15:37.5679829",
      queryUpdatedDate: "0001-01-01T00:00:00",
      querySubject: "I am a test",
      queryText: "yes I am",
      caseId: 1881,
      fromUserId: 4,
      respondedTo: 0,
      isDeleted: 0,
      isClosed: 1,
      closedDate: "2022-09-22T15:15:50.2109401",
    },
    {
      id: 87,
      queryDate: "2022-11-30T11:37:38.1466667",
      queryUpdatedDate: "2022-11-30T11:37:38.1466667",
      querySubject: "Test",
      queryText: "Testing from third party API",
      caseId: 1881,
      fromUserId: 438,
      respondedTo: 0,
      isDeleted: 0,
      isClosed: 0,
      closedDate: "0001-01-01T00:00:00",
    },
  ];
}
